import React, { useContext, useEffect, useState } from 'react'
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
} from '@coreui/react'
import moment from 'moment'
import CaretImg from '../../assets/caret-img.svg'
import ArrowLeft from '../../assets/date-arrow-left.svg'
import ArrowRight from '../../assets/date-arrow-right.svg'
import BluePlusIcon from '../../assets/blue-plus-icon.svg'
import {
  // concatDateTimeToIso,
  // convertToLocalTime,
  convertToNormalDate,
  getMonthDates,
} from 'src/views/utils/helper'
import IPTVContentCard from '../IPTVContentCard/IPTVContentCard'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'
import MonthlyCalendar from './monthlyCalendar'
import useAxios from 'axios-hooks'
import { CONTENT_LIST_FILTER_API, IPTV_CHANNEL_API } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'

const CalendarTable = ({ channelId, setPreviewDetails, addNewDisabled = false }) => {
  const history = useHistory()
  const timeArr = [
    {
      label: '12.00 AM',
      value: '00:00',
      visible: true,
    },
    {
      label: '12.30 AM',
      value: '00:30',
      visible: false,
    },
    {
      label: '1.00 AM',
      value: '01:00',
      visible: true,
    },
    {
      label: '1.00 AM',
      value: '01:30',
      visible: false,
    },
    {
      label: '2.00 AM',
      value: '02:00',
      visible: true,
    },
    {
      label: '2.00 AM',
      value: '02:30',
      visible: false,
    },
    {
      label: '3.00 AM',
      value: '03:00',
      visible: true,
    },
    {
      label: '3.00 AM',
      value: '03:30',
      visible: false,
    },
    {
      label: '4.00 AM',
      value: '04:00',
      visible: true,
    },
    {
      label: '4.00 AM',
      value: '04:30',
      visible: false,
    },
    {
      label: '5.00 AM',
      value: '05:00',
      visible: true,
    },
    {
      label: '5.00 AM',
      value: '05:30',
      visible: false,
    },
    {
      label: '6.00 AM',
      value: '06:00',
      visible: true,
    },
    {
      label: '6.00 AM',
      value: '06:30',
      visible: false,
    },
    {
      label: '7.00 AM',
      value: '07:00',
      visible: true,
    },
    {
      label: '7.00 AM',
      value: '07:30',
      visible: false,
    },
    {
      label: '8.00 AM',
      value: '08:00',
      visible: true,
    },
    {
      label: '8.00 AM',
      value: '08:30',
      visible: false,
    },
    {
      label: '9.00 AM',
      value: '09:00',
      visible: true,
    },
    {
      label: '9.00 AM',
      value: '09:30',
      visible: false,
    },
    {
      label: '10.00 AM',
      value: '10:00',
      visible: true,
    },
    {
      label: '10.00 AM',
      value: '10:30',
      visible: false,
    },
    {
      label: '11.00 AM',
      value: '11:00',
      visible: true,
    },
    {
      label: '11.00 AM',
      value: '11:30',
      visible: false,
    },
    {
      label: '12.00 PM',
      value: '12:00',
      visible: true,
    },
    {
      label: '12.00 PM',
      value: '12:30',
      visible: false,
    },
    {
      label: '1.00 PM',
      value: '13:00',
      visible: true,
    },
    {
      label: '1.00 PM',
      value: '13:30',
      visible: false,
    },
    {
      label: '2.00 PM',
      value: '14:00',
      visible: true,
    },
    {
      label: '2.00 PM',
      value: '14:30',
      visible: false,
    },
    {
      label: '3.00 PM',
      value: '15:00',
      visible: true,
    },
    {
      label: '3.00 PM',
      value: '15:30',
      visible: false,
    },
    {
      label: '4.00 PM',
      value: '16:00',
      visible: true,
    },
    {
      label: '4.00 PM',
      value: '16:30',
      visible: false,
    },
    {
      label: '5.00 PM',
      value: '17:00',
      visible: true,
    },
    {
      label: '5.00 PM',
      value: '17:30',
      visible: false,
    },
    {
      label: '6.00 PM',
      value: '18:00',
      visible: true,
    },
    {
      label: '6.00 PM',
      value: '18:30',
      visible: false,
    },
    {
      label: '7.00 PM',
      value: '19:00',
      visible: true,
    },
    {
      label: '7.00 PM',
      value: '19:30',
      visible: false,
    },
    {
      label: '8.00 PM',
      value: '20:00',
      visible: true,
    },
    {
      label: '8.00 PM',
      value: '20:30',
      visible: false,
    },
    {
      label: '9.00 PM',
      value: '21:00',
      visible: true,
    },
    {
      label: '9.00 PM',
      value: '21:30',
      visible: false,
    },
    {
      label: '10.00 PM',
      value: '22:00',
      visible: true,
    },
    {
      label: '10.00 PM',
      value: '22:30',
      visible: false,
    },
    {
      label: '11.00 PM',
      value: '23:00',
      visible: true,
    },
    {
      label: '11.00 PM',
      value: '23:30',
      visible: false,
    },
  ]
  const { setLoader } = useContext(AppContext)
  const [calendarSchedule, setCalendarSchedule] = useState('WEEKLY')
  const [currentDate, setCurrentDate] = useState(moment().format('D MMM yyyy'))
  const [dates, setDates] = useState([])
  const [addNewProgramKey, setAddNewProgramKey] = useState('')
  const [scheduleData, setScheduleData] = useState([])

  const scheduleObj = {
    DAILY: 'Daily Schedule',
    WEEKLY: 'Weekly Schedule',
    MONTHLY: 'Monthly Schedule',
  }

  const [{ data: channelSchedule, loading: channelScheduleLoading }, channelScheduleCall] =
    useAxios(
      {
        url: `${IPTV_CHANNEL_API}/schedule`,
        method: 'get',
      },
      {
        manual: true,
      },
    )

  const [{ loading: scheduleContentLoading }, scheduleContentCall] = useAxios(
    {
      url: CONTENT_LIST_FILTER_API,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(channelScheduleLoading || scheduleContentLoading)
  }, [channelScheduleLoading, scheduleContentLoading])

  useEffect(async () => {
    if (channelSchedule && channelSchedule.success) {
      let tempSchduleArr = []
      let contentIDs = channelSchedule?.data.map((info) => info?.content_id)
      let contents = await scheduleContentCall({
        data: {
          filters: {
            content_ids: contentIDs,
          },
          page: 1,
          page_size: contentIDs.length,
        },
      })

      for (let i = 0; i < channelSchedule?.data.length; i++) {
        const scheduledContent = channelSchedule?.data[i]
        let contentObj = contents.data?.data.find(
          (content) => content._id === scheduledContent?.content_id,
        )
        // save time in local
        if (contentObj) {
          tempSchduleArr.push({
            ...scheduledContent,
            ...contentObj,
            start_time: new Date(scheduledContent.start_time + 'Z'),
            end_time: new Date(scheduledContent.end_time + 'Z'),
            categoryStr: contentObj.category[0].name,
          })
        }
      }
      setScheduleData([...tempSchduleArr])
    }
  }, [channelSchedule])

  const handleScheduleChange = (value) => {
    setCalendarSchedule(value)
    setCurrentDate(moment().format('D MMM yyyy'))
  }

  useEffect(() => {
    if (!isEmpty(dates)) {
      channelScheduleCall({
        params: {
          channel_id: channelId,
          start_time: moment(dates[0]).startOf('day').toISOString(),
          end_time: moment(dates[dates.length - 1])
            .endOf('day')
            .toISOString(),
        },
      })
    }
  }, [dates])

  useEffect(() => {
    if (calendarSchedule === 'WEEKLY') {
      getFullWeek()
    }
    if (calendarSchedule === 'DAILY') {
      getDailyDate()
    }
    if (calendarSchedule === 'MONTHLY') {
      getMonthlyDate()
    }
  }, [currentDate, calendarSchedule])

  const getFullWeek = () => {
    let weekStart = moment(currentDate).startOf('week')

    let days = []

    for (let i = 0; i <= 6; i++) {
      days.push(moment(weekStart).add(i, 'days').format('D MMM yyyy'))
    }
    setDates(days)
  }
  const getDailyDate = () => {
    setDates([moment(currentDate).format('D MMM yyyy')])
  }
  const getMonthlyDate = () => {
    let month = moment(currentDate).format('MM')
    let year = moment(currentDate).format('YYYY')
    let monthDates = getMonthDates(currentDate, year, month)

    setDates(monthDates)
  }

  console.log('setDates', dates)

  const handleForwardDate = () => {
    let type =
      calendarSchedule === 'DAILY' ? 'days' : calendarSchedule === 'WEEKLY' ? 'weeks' : 'months'
    setCurrentDate((prev) => moment(prev).add(1, type).format('D MMM yyyy'))
  }
  const handleBackwardDate = () => {
    let type =
      calendarSchedule === 'DAILY' ? 'days' : calendarSchedule === 'WEEKLY' ? 'weeks' : 'months'
    setCurrentDate((prev) => moment(prev).subtract(1, type).format('D MMM yyyy'))
  }

  const sameDaySlot = (cardInfo, date, timeSlotHours, timeSlotMinutes) => {
    let dateCheck = moment(date).isSame(moment(cardInfo.start_time).format('D MMM yyyy'))
    let cardInfoHours = moment(cardInfo.start_time).format('HH')
    let cardInfoMinutes = moment(cardInfo.start_time).format('mm')
    let timeCheck =
      timeSlotHours === cardInfoHours &&
      ((Number(timeSlotMinutes) === 30 && Number(cardInfoMinutes) >= 30) ||
        (Number(timeSlotMinutes) === 0 && Number(cardInfoMinutes) < 30))
    // console.log(
    //   'concatDateTimeToIso',
    //   moment(convertToNormalDate(date) + ' ' + time.value, 'DD/MM/YYYY HH:mm').format(
    //     'DD/MM/YYYY HH:mm',
    //   ),
    // )
    if (dateCheck && timeCheck) {
      console.log('cardInfoMinutes', cardInfoMinutes)
      return {
        visible: true,
        marginTop: (Number(cardInfoMinutes) - Number(timeSlotMinutes)) * 1.8,
      }
    }

    return { visible: false, marginTop: '0px' }
  }

  const checkCardSlot = (cardInfo, date, time) => {
    let sameDate = moment(moment(cardInfo.start_time).format('D MMM yyyy')).isSame(
      moment(cardInfo.end_time).format('D MMM yyyy'),
    )
    let concatedDateTime = moment(convertToNormalDate(date) + ' ' + time.value, 'DD/MM/YYYY HH:mm')
    let timeSlotHours = moment(concatedDateTime).format('HH')
    let timeSlotMinutes = moment(concatedDateTime).format('mm')

    if (sameDate) {
      return sameDaySlot(cardInfo, date, timeSlotHours, timeSlotMinutes)
    } else if (!sameDate) {
      let startDateCheck = moment(date).isSame(moment(cardInfo.start_time).format('D MMM yyyy'))
      let endDateCheck =
        moment(date).isSame(moment(cardInfo.end_time).format('D MMM yyyy')) ||
        (moment(date).isAfter(moment(cardInfo.start_time).format('D MMM yyyy')) &&
          moment(date).isBefore(moment(cardInfo.end_time).format('D MMM yyyy')))

      if (startDateCheck) {
        return sameDaySlot(cardInfo, date, timeSlotHours, timeSlotMinutes)
      }
      if (endDateCheck) {
        let timeCheck = timeSlotHours === '00' && Number(timeSlotMinutes) !== 30
        if (timeCheck) {
          return {
            visible: true,
            marginTop: '0px',
          }
        }
      }
    }
    return { visible: false, marginTop: '0px' }
  }

  const getDiffrentDateDuration = (cardInfo, date) => {
    let startDateCheck = moment(date).isSame(moment(cardInfo.start_time).format('D MMM yyyy'))
    let endDateCheckSingle = moment(date).isSame(moment(cardInfo.end_time).format('D MMM yyyy'))
    let endDateCheckMulti =
      moment(date).isAfter(moment(cardInfo.start_time).format('D MMM yyyy')) &&
      moment(date).isBefore(moment(cardInfo.end_time).format('D MMM yyyy'))
    if (startDateCheck) {
      let startTime = cardInfo.start_time
      let endTime = moment(cardInfo.start_time).endOf('day').toString()
      let duration = moment.duration(moment(endTime).diff(startTime)).asMinutes()
      return duration
    }
    if (endDateCheckSingle || endDateCheckMulti) {
      let startTime = moment(cardInfo.end_time).startOf('day').toString()
      let endTime = cardInfo.end_time
      let duration = moment.duration(moment(startTime).diff(startTime))
      if (endDateCheckSingle) {
        duration = moment.duration(moment(endTime).diff(startTime))
      }
      if (endDateCheckMulti) {
        endTime = moment().endOf('day').toString()
        duration = moment.duration(moment(endTime).diff(startTime))
      }
      return duration.asMinutes()
    }
  }
  const calculateHieght = (cardInfo, date) => {
    let sameDate = moment(moment(cardInfo.start_time).format('D MMM yyyy')).isSame(
      moment(cardInfo.end_time).format('D MMM yyyy'),
    )
    if (sameDate) {
      let startTime = cardInfo.start_time
      let endTime = cardInfo.end_time
      let duration = moment.duration(moment(endTime).diff(startTime))
      return duration.asMinutes() < 15 ? 15 * 1.8 : duration.asMinutes() * 1.8
    } else if (!sameDate) {
      let duration = getDiffrentDateDuration(cardInfo, date)
      if (duration) {
        return duration < 15 ? 15 * 1.8 : duration * 1.8
      }
    }
    return 0
  }
  const getCardSize = (cardInfo, date) => {
    let sameDate = moment(moment(cardInfo.start_time).format('D MMM yyyy')).isSame(
      moment(cardInfo.end_time).format('D MMM yyyy'),
    )
    if (sameDate) {
      let startTime = cardInfo.start_time
      let endTime = cardInfo.end_time
      let duration = moment.duration(moment(endTime).diff(startTime)).asMinutes()
      if (duration >= 90 && !cardInfo.draft && calendarSchedule !== 'DAILY') {
        return 'lg'
      } else if (duration >= 60) {
        return 'md'
      } else if (duration >= 30) {
        return 'sm'
      }
      return 'xs'
    } else if (!sameDate) {
      let duration = getDiffrentDateDuration(cardInfo, date)
      if (duration >= 90 && !cardInfo.draft && calendarSchedule !== 'DAILY') {
        return 'lg'
      } else if (duration >= 60) {
        return 'md'
      } else if (duration >= 30) {
        return 'sm'
      }
      return 'xs'
    }
    return 'sm'
  }

  const handleAddNewProgram = (date, time, key) => {
    if (addNewDisabled) {
      return
    }
    for (let index = 0; index < scheduleData.length; index++) {
      const content = scheduleData[index]
      let result = checkCardSlot(content, date, time)
      if (result.visible) return
    }
    setAddNewProgramKey((str) => (str.length > 0 ? '' : key))
  }

  return (
    <div className="pr-5 pl-4">
      <div className="w-100 d-flex justify-content-end align-items-center py-3 position-relative">
        <div
          style={{
            fontSize: '20px',
            fontWeight: '700',
            cursor: 'pointer',
          }}
          className="d-flex justify-content-center align-items-center position-relative schedule-dropdown"
        >
          <button
            style={{
              border: '.5px solid #707070',
              borderRadius: '15px',
              height: '30px',
              width: '163px',
              padding: '5px 23px',
              background: '#fff',
            }}
            className="d-flex align-items-center justify-content-between position-relative mx-4"
          >
            <span style={{ fontSize: '14px' }}>{scheduleObj[calendarSchedule]}</span>
            <img src={CaretImg} className="position-absolute end-0" />
          </button>
          <ul className="position-absolute schedule-dropdown-options list-unstyled" tabIndex={0}>
            {['DAILY', 'WEEKLY', 'MONTHLY'].map((type, idx) => (
              <li key={idx} onClick={() => handleScheduleChange(type)}>
                {scheduleObj[type]}
              </li>
            ))}
          </ul>
        </div>
        <div className="d-flex align-items-center">
          <img src={ArrowLeft} onClick={handleBackwardDate} className="cursor-pointer" />
          <p className="mb-0" style={{ fontSize: '14px', fontWeight: '500' }}>
            {calendarSchedule === 'WEEKLY' && `${dates[0]} - ${dates[dates.length - 1]}`}
            {calendarSchedule === 'DAILY' && `${dates[0]} (${moment(dates[0]).format('dddd')})`}
            {calendarSchedule === 'MONTHLY' && `${moment(dates[0]).format('MMMM YYYY')}`}
          </p>
          <img src={ArrowRight} onClick={handleForwardDate} className="cursor-pointer" />
        </div>
      </div>

      <div
        style={{ maxHeight: '35.1vw', overflowX: 'hidden' }}
        id="scrollableDiv"
        className="mb-2 tableFixHead  custom-scrollbar-vertical "
      >
        {calendarSchedule === 'MONTHLY' ? (
          <MonthlyCalendar
            dates={dates}
            data={JSON.parse(JSON.stringify(scheduleData))}
            onMoreClick={(date) => {
              setCurrentDate(date)
              setCalendarSchedule('WEEKLY')
            }}
          />
        ) : (
          <CTable borderless>
            <CTableHead>
              <CTableRow style={{ textAlign: calendarSchedule === 'DAILY' ? '' : 'center' }}>
                <CTableHeaderCell
                  // scope="col"
                  style={{ backgroundColor: '#fff', width: '5%', zIndex: '' }}
                  className=" p-0 mb-2"
                ></CTableHeaderCell>
                {[...dates].map((val, idx) => (
                  <CTableHeaderCell
                    scope="col"
                    key={idx}
                    style={{
                      backgroundColor: '#fff',
                      borderLeft: '0.5px solid #7e7e7e50',
                      borderRight: '0.5px solid #7e7e7e50',
                    }}
                    className="p-0"
                  >
                    <div
                      className={`w-100 py-2 px-3 d-flex align-items-center`}
                      style={{
                        height: '57px',
                        borderTop: '0.5px solid #7e7e7e50',
                        borderBottom: '0.5px solid #7e7e7e50',
                      }}
                    >
                      {calendarSchedule === 'DAILY' ? (
                        <p style={{ fontSize: '16px' }} className="mb-0">
                          {moment(val).format('D MMMM YYYY (dddd)')}
                        </p>
                      ) : (
                        <div className="d-flex flex-column align-items-center w-100">
                          <p style={{ fontSize: '14px' }} className="mb-0">
                            {moment(val).format('D MMM')}
                          </p>
                          <p
                            style={{
                              fontSize: '12px',
                              color: '#6d6d6d',
                              fontWeight: 'normal',
                            }}
                            className="mb-0 px-2"
                          >
                            ({moment(val).format('dddd')})
                          </p>
                        </div>
                      )}
                    </div>
                  </CTableHeaderCell>
                ))}
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {timeArr.map((time, idx) => {
                return (
                  <CTableRow className="" key={idx} style={{ height: '54px' }}>
                    <CTableDataCell className="p-0 position-relative">
                      {time.visible && (
                        <p
                          style={{ fontSize: '11.5px', top: idx ? '-9px' : '-4px' }}
                          className="mb-0 position-absolute"
                        >
                          {time.label}
                        </p>
                      )}
                    </CTableDataCell>
                    {[...dates].map((date, index) => (
                      <CTableDataCell
                        style={{
                          borderBottom: `0.5px ${
                            idx === timeArr.length - 1 ? 'solid' : 'dashed'
                          }  #7e7e7e50`,
                          borderTop: '0px',
                          borderLeft: '0.5px solid #7e7e7e50',
                          borderRight: '0.5px solid #7e7e7e50',
                        }}
                        className=" p-0 position-relative"
                        key={index}
                        onClick={() => {
                          // console.log(`${date}${time}${index}`)
                          handleAddNewProgram(date, time, `${date}${time.value}`)
                        }}
                      >
                        {addNewProgramKey === `${date}${time.value}` && (
                          <div
                            className="new-program-div"
                            onClick={() => history.push('/content-create')}
                          >
                            <div
                              style={{ width: '5px', background: '#3a68ff' }}
                              className="h-100"
                            />
                            <div className="w-100 h-100 border d-flex flex-col justify-content-center align-items-center">
                              <img src={BluePlusIcon} style={{ width: '24px', height: '24px' }} />
                              <p
                                style={{ color: '#3a68ff', fontSize: '12px', fontWeight: '500' }}
                                className="mb-0"
                              >
                                Add a new Program
                              </p>
                            </div>
                          </div>
                        )}

                        {scheduleData.map((info, cardIndex) => {
                          let slotObj = checkCardSlot(info, date, time)
                          let isVisible = slotObj.visible
                          let cardMarginTop = slotObj.marginTop
                          let cardHieght = calculateHieght(info, date)
                          let cardSize = getCardSize(info, date)
                          return isVisible ? (
                            <div style={{ marginTop: '1.1px' }}>
                              <IPTVContentCard
                                data={info}
                                cardMarginTop={cardMarginTop}
                                cardWidth={calendarSchedule === 'DAILY' ? '99.5%' : '93%'}
                                cardHieght={cardHieght - 3}
                                cardSize={cardSize}
                                isDraft={info.publish_policy === 'DRAFT'}
                                isDaily={calendarSchedule === 'DAILY'}
                                onPreviewClick={() => {
                                  setAddNewProgramKey('')
                                  setPreviewDetails(info)
                                }}
                              />
                            </div>
                          ) : (
                            ''
                          )
                        })}
                      </CTableDataCell>
                    ))}
                  </CTableRow>
                )
              })}
            </CTableBody>
          </CTable>
        )}
      </div>
    </div>
  )
}

export default CalendarTable
